export const COLORS = [
  '#F4A83B',
  '#29ABE2',
  '#A185DC',
  '#72B566',
  '#EA7470',
  '#F3C85C',
  '#3CC8D1',
  '#EC3323',
  '#6F81DF',
  '#E74EB3',
];

export const AVATAR_COLORS = {
  color1: '#72B566',
  color2: '#9766C9',
  color3: '#66B5B0',
  color4: '#E74EB3',
  color5: '#E64E7C',
  color6: '#EC3323',
  color7: '#3CC8D1',
  color8: '#EA7470',
  color9: '#29ABE2',
  color10: '#F4A83B',
  color11: '#6F81DF',
  color12: '#FFED8B',
  color13: '#F3C85C',
};

export const INITIAL_DASHBOARD_MODAL_FORM_DATA = {
  dashboardName: '',
  dashboardDescription: '',
  selectedImageOptionId: 'DISABLED',
  selectedPermissionSettingsId: 1,
  image: null,
  isShared: false,
  isFavorite: false,
};

export const LATEST_VIEW_DASHBOARD_LIBRARY = 'dashboardLibrary';

export const INITIAL_WIDGETS_FILTER_PARAMS = {
  searchCriteria: '',
  selectedTagsOptions: [],
};

export const NOTIFICATIONS_TYPES = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error',
};
